import { Link } from 'react-router-dom'
import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'

interface HelpButtonProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  variant?: 'floating' | 'inline'
}

export default function HelpButton({
  className,
  size = 'md',
  variant = 'floating'
}: HelpButtonProps) {
  const sizeClasses = {
    sm: 'h-10 w-10',
    md: 'h-12 w-12',
    lg: 'h-14 w-14',
  }

  const iconSizeClasses = {
    sm: 'h-5 w-5',
    md: 'h-6 w-6',
    lg: 'h-7 w-7',
  }

  if (variant === 'inline') {
    return (
      <Link
        to="/help"
        className={clsx(
          'inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-primary-600 transition-colors',
          className
        )}
        title="Apri Guida"
      >
        <QuestionMarkCircleIcon className={iconSizeClasses[size]} />
        <span>Guida</span>
      </Link>
    )
  }

  return (
    <Link
      to="/help"
      className={clsx(
        'fixed bottom-6 right-6 z-50',
        'flex items-center justify-center',
        sizeClasses[size],
        'bg-primary-600 hover:bg-primary-700',
        'text-white rounded-full shadow-lg hover:shadow-xl',
        'transition-all duration-200 transform hover:scale-105',
        'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
        className
      )}
      title="Apri Guida"
      aria-label="Apri guida utente"
    >
      <QuestionMarkCircleIcon className={iconSizeClasses[size]} />
    </Link>
  )
}
